import { Empty, Typography } from 'antd';
import { Trans } from 'react-i18next';
import { createSearchParams, Link, useSearchParams } from 'react-router-dom';

import useAPIQuery from '../../api/useAPIQuery';
import { CandidateDetail } from '../../types';
import styles from './CandidateVacancies.module.css';

interface CandidateVacanciesProps {
  candidateId: CandidateDetail['id'];
}

const createHistorySearchParams = (searchParams: URLSearchParams) => {
  searchParams.set('historyFilters', 'JOB_APPLICATION');
  searchParams.set('historyPage', '1');
  return createSearchParams(searchParams).toString();
};

const CandidateVacancies = ({ candidateId }: CandidateVacanciesProps) => {
  const [searchParams] = useSearchParams();

  const recruitmentProcesses = useAPIQuery([
    '/recruitment-processes/',
    {
      params: {
        candidate: candidateId,
        page_size: 5,
        ordering: '-created_at',
      },
    },
  ]);

  return (recruitmentProcesses.data?.count ?? 0) > 0 ? (
    <ul className={styles.ul}>
      {recruitmentProcesses.data?.results?.map((recruitmentProcess) => (
        <li
          key={recruitmentProcess.id}
          data-testid={`candidate-current-stage-${recruitmentProcess.id}`}
          className={recruitmentProcess?.status === 'INACTIVE' ? styles.errorLi : styles.sucessLi}
        >
          <Typography.Text data-testid="candidate-current-stage">
            {recruitmentProcess.job_posting.id} - {recruitmentProcess.job_posting.name} (
            <Typography.Text>{recruitmentProcess.stage.name ?? '-'}</Typography.Text>)
          </Typography.Text>
        </li>
      ))}
      {(recruitmentProcesses.data?.count ?? 0) > 1 && (
        <li>
          <Link
            className="ant-typography-link"
            data-testid="show-more-link"
            to={{
              pathname: `candidates/${candidateId}/history`,
              search: createHistorySearchParams(searchParams),
            }}
          >
            <Trans>Ver mais</Trans>
          </Link>
        </li>
      )}
    </ul>
  ) : (
    <Empty data-testid="empty-information-component" image={Empty.PRESENTED_IMAGE_SIMPLE} />
  );
};

export default CandidateVacancies;
